/* eslint-disable no-undef */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */

// Cookie Control - v9.10.1 configuration for ADV
// Modes:
// 1) Forced CCPA test mode (?force_ccpa=1): loads Cookie Control in CCPA mode (no geo)
// 2) Production geo mode:
//    - GDPR mode (opt-in) in EU, GB (UK), and BR (Brazil)
//    - CCPA mode (opt-out) if withinCCPA is true, or if US + CA
//    - Elsewhere: loads Cookie Control in "closed" state and auto-accepts all optional categories
//      (analytics, advertising, functional, socialsharing) only if no prior preferences exist
// Fallback:
// - If geo lookup does not return a usable geo object, we fail closed: Cookie Control is not loaded,
//   and non-essential scripts are not injected from this file.

(function () {
  // ============================================================================
  // PHONE FLASH REDUCTION
  // Inject CSS to hide phone elements until they're updated with the correct number.
  // Note: This minimizes but doesn't fully prevent the flash because this script
  // loads in the footer (Odysseus constraint). Full prevention would require
  // moving the script to the head or server-side cookie detection.
  // ============================================================================
  var hasGeoPhoneCookie = document.cookie.indexOf('geoPhoneOpts=') !== -1;
  var hasFunctionalConsentEarly = false;
  try {
    var ccMatch = document.cookie.match(/(?:^|;\s*)CookieControl=([^;]*)/);
    if (ccMatch && ccMatch[1]) {
      var ccData = JSON.parse(decodeURIComponent(ccMatch[1]));
      hasFunctionalConsentEarly = ccData && ccData.optionalCookies && ccData.optionalCookies.functional === 'accepted';
    }
  } catch (e) {
    // no-op
  }

  if (hasGeoPhoneCookie && hasFunctionalConsentEarly) {
    var style = document.createElement('style');
    style.id = 'cc-phone-hide-flash';
    style.textContent = '#header_main_phone,#slogan .phone,#need_help_container #not_mobile,#need_help_container .mobile .text,.js-contact-us{visibility:hidden!important}';
    (document.head || document.documentElement || document.body).appendChild(style);
  }
  // ============================================================================

  // Helper flags
  const FORCE_CCPA = /(?:\?|&)force_ccpa=1\b/i.test(location.search);
  const CIVIC_API_KEY = '8b610e1a5bdd7adf6e63a841ff54a89c78ee89a0'; // ADC

  // Global Privacy Control (GPC) signal (used throughout this file)
  const HAS_GPC =
    typeof navigator !== 'undefined' &&
    navigator.globalPrivacyControl === true;

  // A GPC signal is a request to opt out of selling and sharing personal information, which state privacy laws
  // say must be honored (CCPA regulations §7025) even if the visitor accepted these cookies before. These are the
  // categories that send data to advertising or analytics partners, so while the signal is on they never load,
  // any earlier acceptance is revoked on load, and the panel says the opt-out was honored (§7025 requires showing it)
  const GPC_OPT_OUT_CATEGORIES = ['analytics', 'advertising', 'socialsharing'];
  const GPC_HONORED_TEXT = 'Opt-Out Request Honored: your browser\'s Global Privacy Control signal is on, so ' +
    'analytics, advertising and social sharing cookies are off for this browser.';

  function withGpcText (text) {
    return HAS_GPC ? GPC_HONORED_TEXT + ' ' + text : text;
  }

  // Wraps a Cookie Control config so that, with GPC on, categories accepted on an earlier visit are switched off once
  // Cookie Control has loaded (their onRevoke handlers clear the cookies). Their onAccept handlers already return early
  function withGpcOptOut (config) {
    if (!HAS_GPC) {
      return config;
    }
    var previousOnLoad = config.onLoad;
    config.onLoad = function () {
      if (typeof previousOnLoad === 'function') {
        previousOnLoad.apply(this, arguments);
      }
      try {
        var revoked = false;
        config.optionalCookies.forEach(function (category, index) {
          if (GPC_OPT_OUT_CATEGORIES.indexOf(category.name) !== -1 && window.CookieControl.getCategoryConsent(index)) {
            window.CookieControl.changeCategory(index, false);
            revoked = true;
          }
        });
        // A returning visitor's saved choice keeps the banner closed; show it so they see the notice
        if (revoked && typeof window.CookieControl.notify === 'function') {
          window.CookieControl.notify();
        }
      } catch (e) {
        console.warn('[CookieControl] Could not apply the GPC opt-out to saved choices:', e);
      }
    };
    return config;
  }

  // While GPC is on, a tracking category the visitor switches on in the panel is switched straight back off (its
  // onAccept has already returned early), so the panel never shows an opt-in the signal overrides, and the notice shows
  function revokeForGpc (name) {
    setTimeout(function () {
      try {
        var categories = window.CookieControl.config().optionalCookies;
        for (var i = 0; i < categories.length; i++) {
          if (categories[i].name === name && window.CookieControl.getCategoryConsent(i)) {
            window.CookieControl.changeCategory(i, false);
            if (typeof window.CookieControl.notify === 'function') {
              window.CookieControl.notify();
            }
          }
        }
      } catch (e) {
        console.warn('[CookieControl] Could not undo a category switched on while GPC is on:', e);
      }
    }, 0);
  }

  // Cloudflare Web Analytics (real-visitor page speed). Cloudflare's automatic setup would add its script to every
  // page outside Cookie Control, so it is installed manually and loaded here with Analytics consent instead: EU
  // visitors opt in, UK visitors can object, and GPC turns it off as it does the rest of Analytics. It loads only on
  // the hostnames Cloudflare proxies, the pages the automatic setup measured, so Odysseus pages stay unmeasured.
  // It sets no cookies; a revoke takes effect from the next page, as the script cannot be unloaded.
  const CF_WEB_ANALYTICS_TOKEN = '22dd4fc45a2d41678a5b342e131b2202';
  const CF_WEB_ANALYTICS_HOSTS = ['www.americandiscountvacations.com', 'americandiscountvacations.com'];
  function loadCloudflareWebAnalytics () {
    // Never lets a failure here stop the rest of the Analytics category from loading
    try {
      if (CF_WEB_ANALYTICS_HOSTS.indexOf(window.location.hostname) === -1) return;
      // Also skips the script Cloudflare's automatic setup adds, while that is still switched on
      if (document.querySelector('script[src^="https://static.cloudflareinsights.com/beacon.min.js"]')) return;
      var s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://static.cloudflareinsights.com/beacon.min.js';
      s.setAttribute('data-cf-beacon', JSON.stringify({ token: CF_WEB_ANALYTICS_TOKEN }));
      (document.head || document.documentElement).appendChild(s);
    } catch (e) {
      console.warn('[CookieControl] Could not load Cloudflare Web Analytics:', e);
    }
  }

  // Simple cookie check function available throughout the file
  function hasCookieControlConsent () {
    try {
      var match = document.cookie.match(/(?:^|;\s*)CookieControl=([^;]*)/);
      if (!match) return false;
      var parsed = JSON.parse(decodeURIComponent(match[1]));
      var opts = parsed && parsed.optionalCookies;
      // A recorded choice, not merely the cookie's presence. Civic writes the cookie with an
      // empty optionalCookies the moment it presents the statement, and sets interactedWith
      // true at the same point, so neither the cookie nor that flag means the visitor chose.
      // Only a populated optionalCookies does. Verified against production: the cookie passes
      // through {"opt":{},"inter":true} on its way to the populated state.
      // Object.keys alone would accept a string or an array, so a tampered
      // {"optionalCookies":"x"} would read as consent. Require a plain object.
      return !!opts && typeof opts === 'object' && !Array.isArray(opts) && Object.keys(opts).length > 0;
    } catch (e) {
      return false;
    }
  }

  // Flag to block onAccept handlers from firing before user makes a choice in CCPA mode
  // Initially set for forced CCPA mode; also set later in geoTest callback for CA users
  const IS_CCPA_MODE = FORCE_CCPA;
  window.__ccpaBlockOnAccept = IS_CCPA_MODE && !hasCookieControlConsent();

  // Check if user has explicitly accepted any cookies (not just that a cookie exists)
  function hasUserAcceptedAnyCookies () {
    try {
      const raw = document.cookie.match(/(?:^|;\s*)CookieControl=([^;]*)/);
      if (raw && raw[1]) {
        const consent = JSON.parse(decodeURIComponent(raw[1]));
        return consent.optionalCookies && (
          consent.optionalCookies.analytics === 'accepted' ||
          consent.optionalCookies.advertising === 'accepted' ||
          consent.optionalCookies.functional === 'accepted' ||
          consent.optionalCookies.socialsharing === 'accepted'
        );
      }
    } catch (e) {
      // no-op
    }
    return false;
  }

  // Pre-inject CSS to hide toggles for potential CCPA users (prevents flash of ON state)
  // This will be removed for non-CCPA regions or after toggles are set correctly
  // Only inject if user hasn't explicitly accepted cookies
  if (!hasUserAcceptedAnyCookies()) {
    const earlyHideStyle = document.createElement('style');
    earlyHideStyle.id = 'ccpa-hide-toggles';
    earlyHideStyle.textContent = [
      '.checkbox-toggle { visibility: hidden !important; opacity: 0 !important; }',
      '.checkbox-toggle-input { pointer-events: none; }',
      '.ccc-content--open .optional-cookie .checkbox-toggle { visibility: hidden !important; opacity: 0 !important; }',
      '.optional-cookie {',
      '  position: relative;',
      '}',
      '.optional-cookie::after {',
      '  content: "";',
      '  position: absolute;',
      '  top: 10px;',
      '  right: 20px;',
      '  width: 24px;',
      '  height: 24px;',
      '  border: 3px solid #999;',
      '  border-top-color: #fff;',
      '  border-radius: 50%;',
      '  animation: ccpa-spin 0.8s linear infinite;',
      '}',
      '@keyframes ccpa-spin {',
      '  to { transform: rotate(360deg); }',
      '}'
    ].join('\n');
    document.head.appendChild(earlyHideStyle);
  }

  // ==========================================================================
  // GEOLOCATION: Phone Number Setup (Consent-Aware)
  // ==========================================================================
  // Logic:
  // 1. Check UTM params first
  //    - If present: call campaign-phones API, display that number immediately
  // 2. No UTM params + no functional consent:
  //    - Show US/Canada toll-free (1-855-602-7447)
  //    - Show "Not calling from US/Canada?" link with qTip for international numbers
  // 3. Functional consent granted:
  //    - geolocation.js loads and handles regional detection via ipstack
  //
  // Phone number rules:
  // - US/CA/territories: 1-855-602-7447 (toll-free)
  // - GB (UK): 0800 098 8041 (toll-free)
  // - International: +1-732-970-9142
  // ==========================================================================

  /**
   * Parse URL parameters from a URL string.
   * @param {string} url - The URL to parse
   * @returns {object} - Object with param keys and values
   */
  /**
   * Whether a URL points at this page's own origin. For a signed-in user, API_URL is this site's
   * api-proxy, which only answers requests carrying X-Requested-With. Visitors who aren't signed
   * in call the API on its own origin, where adding a custom header would only force a CORS
   * preflight, so the header is sent to this origin only.
   */
  function isThisOrigin (url) {
    try {
      return new URL(url, window.location.href).origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function proxyHeaders (url) {
    return isThisOrigin(url) ? { 'X-Requested-With': 'XMLHttpRequest' } : {};
  }

  function getUrlParams (url) {
    var params = {};
    try {
      var urlSplit = url.split('?');
      if (urlSplit[1]) {
        var paramsString = urlSplit[1].split('#')[0]; // Remove hash if present
        var pairs = paramsString.split('&');
        for (var i = 0; i < pairs.length; i++) {
          var pair = pairs[i].split('=');
          if (pair[0]) {
            params[pair[0]] = pair[1] ? decodeURIComponent(pair[1]) : '';
          }
        }
      }
    } catch (e) {
      // no-op
    }
    return params;
  }

  /**
   * Check if URL has UTM advertising parameters.
   * @returns {boolean}
   */
  function hasUtmParams () {
    var url = window.location.href;
    return url.indexOf('utm_source') > -1 && url.indexOf('utm_campaign') > -1;
  }

  /**
   * Decorate all internal <a> links on the same root domain (including subdomains)
   * with UTM params so campaign phone persists across page navigations without
   * depending on cookies/sessionStorage.
   * Runs once on DOMContentLoaded (or immediately if DOM already loaded).
   */
  function decorateLinksWithUtm () {
    var params = getUrlParams(window.location.href);
    var utmSource = params.utm_source || '';
    var utmCampaign = params.utm_campaign || '';
    if (!utmSource || !utmCampaign) return;

    var utmString = 'utm_source=' + encodeURIComponent(utmSource) +
                    '&utm_campaign=' + encodeURIComponent(utmCampaign);
    if (params.utm_medium) utmString += '&utm_medium=' + encodeURIComponent(params.utm_medium);
    if (params.utm_term) utmString += '&utm_term=' + encodeURIComponent(params.utm_term);
    if (params.utm_content) utmString += '&utm_content=' + encodeURIComponent(params.utm_content);

    // Extract root domain for subdomain matching (e.g. "americandiscountvacations.com")
    var hostParts = window.location.hostname.split('.');
    var rootDomain = hostParts.length >= 2
      ? hostParts.slice(-2).join('.')
      : window.location.hostname;

    function decorateLink (a) {
      var href = a.getAttribute('href');
      if (!href) return;
      if (href.charAt(0) === '#' || href.indexOf('javascript:') === 0 ||
          href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      // Skip fancybox/lightbox links (open modals, not new pages)
      // Check for any data-fancybox* attribute (data-fancybox, data-fancybox-type, etc.)
      var attrs = a.attributes;
      for (var ai = 0; ai < attrs.length; ai++) {
        if (attrs[ai].name.indexOf('data-fancybox') === 0 ||
            attrs[ai].name.indexOf('data-lightbox') === 0) return;
      }
      if ((a.className && /fancybox|lightbox/i.test(a.className)) ||
          (a.getAttribute('rel') && /fancybox|lightbox/i.test(a.getAttribute('rel')))) return;
      // Skip URLs with /fancybox/ in the path (same-domain iframe popups)
      if (href.indexOf('/fancybox/') > -1) return;
      // Skip links to images (often fancybox galleries)
      if (/\.(jpg|jpeg|png|gif|webp|svg|bmp)(\?|#|$)/i.test(href)) return;
      if (href.indexOf('utm_source') > -1) return;
      // For absolute URLs, only decorate if same root domain (includes subdomains)
      if (href.indexOf('//') > -1) {
        try {
          var linkHost = new URL(href).hostname.toLowerCase();
          var normalizedRoot = rootDomain.toLowerCase();
          if (linkHost !== normalizedRoot && !linkHost.endsWith('.' + normalizedRoot)) return;
        } catch (e) { return; }
      }
      var separator = href.indexOf('?') > -1 ? '&' : '?';
      var hashIdx = href.indexOf('#');
      if (hashIdx > -1) {
        a.setAttribute('href', href.substring(0, hashIdx) + separator + utmString + href.substring(hashIdx));
      } else {
        a.setAttribute('href', href + separator + utmString);
      }
    }

    function decorateAll () {
      var links = document.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) {
        decorateLink(links[i]);
      }
      if (typeof MutationObserver === 'function') {
        var observer = new MutationObserver(function (mutations) {
          for (var m = 0; m < mutations.length; m++) {
            var addedNodes = mutations[m].addedNodes;
            for (var n = 0; n < addedNodes.length; n++) {
              var node = addedNodes[n];
              if (node.nodeType === 1) {
                if (node.tagName === 'A') decorateLink(node);
                var innerLinks = node.querySelectorAll ? node.querySelectorAll('a[href]') : [];
                for (var j = 0; j < innerLinks.length; j++) {
                  decorateLink(innerLinks[j]);
                }
              }
            }
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', decorateAll);
    } else {
      decorateAll();
    }
  }

  /**
   * Detect if user is on a mobile device (simple check).
   * @returns {boolean}
   */
  function isMobileDevice () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  /**
   * Remove the phone hide CSS that was injected for flash prevention.
   */
  function removePhoneHideCSS () {
    var hideStyle = document.getElementById('cc-phone-hide-flash');
    if (hideStyle) {
      hideStyle.parentNode.removeChild(hideStyle);
    }
  }

  /**
   * Set phone number fields in the DOM.
   * @param {string} phoneNum - The phone number to display
   * @param {string} footerString - Text for desktop footer
   * @param {string} footerStringMobile - Text for mobile footer
   * @param {boolean} mobileCallUsBtn - Whether to show mobile call button
   * @param {boolean} mobilePhoneLinkFancy - Whether to use fancybox for mobile link
   */
  function setDefaultPhoneFields (phoneNum, footerString, footerStringMobile, mobileCallUsBtn, mobilePhoneLinkFancy) {
    try {
      var applyPhoneFields = function () {
        var headerPhone = document.getElementById('header_main_phone');
        if (headerPhone) headerPhone.textContent = phoneNum;

        var needHelpContainer = document.getElementById('need_help_container');
        if (needHelpContainer) {
          var notMobile = needHelpContainer.querySelector('#not_mobile');
          if (notMobile) notMobile.textContent = footerString;

          var mobileText = needHelpContainer.querySelector('.mobile>.text');
          if (mobileText) mobileText.textContent = footerStringMobile;

          var mobileLink = needHelpContainer.querySelector('.mobile>a');
          if (mobileLink) {
            if (mobileCallUsBtn) {
              mobileLink.setAttribute('href', 'tel:' + phoneNum);
              mobileLink.style.display = '';
            } else {
              mobileLink.style.display = 'none';
            }
          }
        }

        // Update .js-contact-us elements
        var contactUsElements = document.querySelectorAll('.js-contact-us');
        for (var ci = 0; ci < contactUsElements.length; ci++) {
          contactUsElements[ci].textContent = phoneNum;
          contactUsElements[ci].setAttribute('href', 'tel:' + phoneNum);
        }

        // Handle mobile phone link with fancybox
        var mobilePhoneLink = document.getElementById('mobile_phone_link');
        if (mobilePhoneLink) {
          if (mobilePhoneLinkFancy) {
            mobilePhoneLink.setAttribute('href', '#');
          } else {
            mobilePhoneLink.setAttribute('href', 'tel:' + phoneNum);
          }
        }

        // Remove the hiding CSS now that phone is set correctly
        removePhoneHideCSS();
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyPhoneFields);
      } else {
        applyPhoneFields();
      }
    } catch (e) {
      // Ensure hiding CSS is removed even on error
      removePhoneHideCSS();
    }
  }

  /**
   * HTML content for the phone options fancybox/modal.
   * Shown when user clicks phone elements without consent granted.
   */
  var phoneOptionsFancyboxContent =
    '<div style="padding:10px;text-align:left;">' +
    '<p style="font-weight:bold;margin-bottom:15px;font-size:16px;text-decoration:underline;">Contact us by Phone</p>' +
    '<p style="margin-bottom:10px;"><strong>US &amp; Canada (Toll Free):</strong><br>' +
    '<a href="tel:1-855-602-7447" style="color:#004a83;font-size:18px;">1-855-602-7447</a></p>' +
    '<p style="margin-bottom:10px;"><strong>United Kingdom (Call Free):</strong><br>' +
    '<a href="tel:08000988041" style="color:#004a83;font-size:18px;">0800 098 8041</a></p>' +
    '<p><strong>International:</strong><br>' +
    '<a href="tel:+1-732-970-9142" style="color:#004a83;font-size:18px;">+1-732-970-9142</a></p>' +
    '</div>';

  /**
   * Shim jQuery.browser if missing (removed in jQuery 1.9+).
   * qTip internally reads $.browser.mozilla, $.browser.webkit, etc.
   * Without this shim, qTip init may succeed but rendering can crash.
   */
  function shimJQueryBrowser () {
    if (typeof jQuery !== 'undefined' && !jQuery.browser) {
      var ua = navigator.userAgent.toLowerCase();
      jQuery.browser = {
        mozilla: /mozilla/.test(ua) && !/webkit/.test(ua) && !/msie/.test(ua),
        webkit: /webkit/.test(ua),
        opera: /opera/.test(ua),
        msie: /msie/.test(ua)
      };
    }
  }

  /**
   * Detect if we're on an Odysseus-hosted subdomain page (e.g. booking.americandiscountvacations.com).
   * qTip is incompatible with the Odysseus jQuery/vendor bundle and crashes at render time,
   * so we skip qTip entirely on these pages and use fancybox instead.
   */
  function isOdysseusPage () {
    var hostname = window.location.hostname;
    var parts = hostname.split('.');
    if (parts.length <= 2) return false;
    var odysseusSubdomains = ['deals', 'insider', 'globaldeals', 'booking', 'ic'];
    return odysseusSubdomains.indexOf(parts[0]) !== -1;
  }

  /**
   * Inject the "Not calling from US/Canada?" fallback message and set up
   * fancybox handlers for mobile/small viewport phone elements.
   * Only shown when functional consent is not granted and no UTM params.
   */
  function injectGeoFallbackMessage () {
    try {
      var applyFallback = function () {
        // Don't inject if already present
        if (document.getElementById('geo_fallback_msg')) return;

        // Don't inject if geolocation.js has already loaded (user accepted consent quickly)
        if (window.__geolocationLoaded) return;

        // Don't inject if geolocation.js already removed the fallback (race condition prevention)
        if (window.__geoFallbackRemoved) return;

        // =================================================================
        // HEADER (Desktop): "Not calling from US/Canada?" qTip link
        // =================================================================
        var sloganDiv = document.querySelector('#header #slogan');
        if (sloganDiv) {
          var phoneDiv = sloganDiv.querySelector('.phone');
          if (phoneDiv) {
            // Add bottom margin to phone div to accommodate the message
            phoneDiv.style.marginBottom = '11px';

            // Create the fallback message element
            var fallbackDiv = document.createElement('div');
            fallbackDiv.id = 'geo_fallback_msg';
            fallbackDiv.style.cssText = 'font-size:12px;margin-top:0;margin-bottom:15px;';
            fallbackDiv.innerHTML =
              '<a class="my_qtip" href="#">Not calling from the US/Canada?</a>' +
              '<span class="qtip_content hide">' +
              '<p>Here are other phone numbers you can reach us at:<br>' +
              '&bull; United Kingdom: 0800 098 8041 (call free)<br>' +
              '&bull; International: +1-732-970-9142</p>' +
              '</span>';

            // Insert after the phone div
            phoneDiv.parentNode.insertBefore(fallbackDiv, phoneDiv.nextSibling);

            // Initialize qTip on the new element (or fancybox if qTip unavailable)
            // Use retry mechanism to ensure jQuery/qTip/fancybox are fully loaded
            var qtipRetryCount = 0;
            var maxQtipRetries = 10;
            var qtipRetryDelay = 200; // ms

            var initQtip = function () {
              if (typeof jQuery !== 'undefined' && typeof jQuery.fn.qtip === 'function') {
                shimJQueryBrowser();
                try {
                  var $qtipEl = jQuery('#geo_fallback_msg .my_qtip');
                  if ($qtipEl.length > 0) {
                    $qtipEl.on('click', function (e) { e.preventDefault(); });
                    var qtipHtml = $qtipEl.next('.qtip_content').html();
                    $qtipEl.qtip({
                      content: { text: qtipHtml },
                      hide: { event: 'unfocus' },
                      style: { classes: 'qtip-youtube qtip-shadow', width: 300 },
                      position: { viewport: jQuery(window), adjust: { method: 'flip' } },
                      show: { solo: true }
                    });
                    return; // Success
                  }
                } catch (e) {
                  // qTip crashed (e.g. $.browser removed in newer jQuery) — fall back to fancybox
                  console.warn('qTip init failed, falling back to fancybox:', e.message);
                  initHeaderFancyboxFallback();
                  return;
                }
              }

              if (qtipRetryCount < maxQtipRetries) {
                qtipRetryCount++;
                setTimeout(initQtip, qtipRetryDelay);
              } else {
                // qTip never loaded — fall back to fancybox with its own retry loop
                initHeaderFancyboxFallback();
              }
            };

            var fancyboxRetryCount = 0;
            var maxFancyboxRetries = 15;
            var fancyboxRetryDelay = 300; // ms

            var initHeaderFancyboxFallback = function () {
              if (typeof jQuery !== 'undefined' && typeof jQuery.fn.fancybox === 'function') {
                jQuery('#geo_fallback_msg .my_qtip').off('click').on('click', function (e) {
                  e.preventDefault();
                  jQuery.fancybox(phoneOptionsFancyboxContent, {
                    openEffect: 'elastic',
                    closeEffect: 'elastic'
                  });
                });
                return; // Success
              }

              if (fancyboxRetryCount < maxFancyboxRetries) {
                fancyboxRetryCount++;
                setTimeout(initHeaderFancyboxFallback, fancyboxRetryDelay);
              }
            };

            // On Odysseus pages, skip qTip (crashes at render time) and use fancybox directly
            if (isOdysseusPage()) {
              setTimeout(initHeaderFancyboxFallback, 500);
            } else {
              setTimeout(initQtip, 500);
            }
          }
        }

        // =================================================================
        // HEADER (Mobile): Phone icon → fancybox with all numbers
        // Applies at ≤720px viewport (when #mobile_btns is visible)
        // =================================================================
        var mobilePhoneBtn = document.getElementById('mobile_phone_link');
        if (mobilePhoneBtn && typeof jQuery !== 'undefined' && typeof jQuery.fn.fancybox === 'function') {
          // Store original href so we can restore it later
          mobilePhoneBtn.setAttribute('data-original-href', mobilePhoneBtn.getAttribute('href') || '');
          mobilePhoneBtn.setAttribute('href', '#');
          mobilePhoneBtn.setAttribute('data-geo-fallback', 'true');

          jQuery(mobilePhoneBtn).off('click.geoFallback').on('click.geoFallback', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Open fancybox immediately
            jQuery.fancybox(phoneOptionsFancyboxContent, {
              openEffect: 'elastic',
              closeEffect: 'elastic'
            });
          });
        }

        // =================================================================
        // FOOTER (Mobile): "Call Us" button → fancybox with all numbers
        // =================================================================
        var footerCallBtn = document.querySelector('#need_help_container .mobile > a');
        if (footerCallBtn && typeof jQuery !== 'undefined' && typeof jQuery.fn.fancybox === 'function') {
          // Store original href so we can restore it later
          footerCallBtn.setAttribute('data-original-href', footerCallBtn.getAttribute('href') || '');
          footerCallBtn.setAttribute('href', '#');
          footerCallBtn.setAttribute('data-geo-fallback', 'true');

          jQuery(footerCallBtn).off('click.geoFallback').on('click.geoFallback', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Open fancybox immediately
            jQuery.fancybox(phoneOptionsFancyboxContent, {
              openEffect: 'elastic',
              closeEffect: 'elastic'
            });
          });
        }

        // =================================================================
        // FOOTER (Desktop): Add "Not calling from US/Canada?" link
        // Hidden at ≤660px since "Call Us" button handles that case
        // =================================================================
        var footerNotMobile = document.querySelector('#need_help_container #not_mobile');
        if (footerNotMobile && !document.getElementById('geo_fallback_footer_msg')) {
          // Inject responsive style if not already present
          if (!document.getElementById('geo_fallback_footer_style')) {
            var styleTag = document.createElement('style');
            styleTag.id = 'geo_fallback_footer_style';
            styleTag.textContent = '@media (max-width: 660px) { #geo_fallback_footer_msg { display: none !important; } }';
            document.head.appendChild(styleTag);
          }

          var footerFallbackDiv = document.createElement('div');
          footerFallbackDiv.id = 'geo_fallback_footer_msg';
          footerFallbackDiv.style.cssText = 'font-size:12px;font-weight:normal;margin-top:11px;';
          footerFallbackDiv.innerHTML =
            '<a class="my_qtip" href="#">Not calling from the US/Canada?</a>' +
            '<span class="qtip_content hide">' +
            '<p>Here are other phone numbers you can reach us at:<br>' +
            '&bull; United Kingdom: 0800 098 8041 (call free)<br>' +
            '&bull; International: +1-732-970-9142</p>' +
            '</span>';

          footerNotMobile.parentNode.insertBefore(footerFallbackDiv, footerNotMobile.nextSibling);

          // Initialize qTip (or fancybox if qTip unavailable)
          // Use retry mechanism to ensure jQuery/qTip/fancybox are fully loaded
          var footerQtipRetryCount = 0;
          var maxFooterQtipRetries = 10;
          var footerQtipRetryDelay = 200; // ms

          var initFooterQtip = function () {
            if (typeof jQuery !== 'undefined' && typeof jQuery.fn.qtip === 'function') {
              shimJQueryBrowser();
              try {
                var $footerQtipEl = jQuery('#geo_fallback_footer_msg .my_qtip');
                if ($footerQtipEl.length > 0) {
                  $footerQtipEl.on('click', function (e) { e.preventDefault(); });
                  var footerQtipHtml = $footerQtipEl.next('.qtip_content').html();
                  $footerQtipEl.qtip({
                    content: { text: footerQtipHtml },
                    hide: { event: 'unfocus' },
                    style: { classes: 'qtip-youtube qtip-shadow', width: 300 },
                    position: { viewport: jQuery(window), adjust: { method: 'flip' } },
                    show: { solo: true }
                  });
                  return; // Success
                }
              } catch (e) {
                // qTip crashed — fall back to fancybox
                console.warn('Footer qTip init failed, falling back to fancybox:', e.message);
                initFooterFancyboxFallback();
                return;
              }
            }

            if (footerQtipRetryCount < maxFooterQtipRetries) {
              footerQtipRetryCount++;
              setTimeout(initFooterQtip, footerQtipRetryDelay);
            } else {
              // qTip never loaded — fall back to fancybox with its own retry loop
              initFooterFancyboxFallback();
            }
          };

          var footerFancyboxRetryCount = 0;
          var maxFooterFancyboxRetries = 15;
          var footerFancyboxRetryDelay = 300; // ms

          var initFooterFancyboxFallback = function () {
            if (typeof jQuery !== 'undefined' && typeof jQuery.fn.fancybox === 'function') {
              jQuery('#geo_fallback_footer_msg .my_qtip').off('click').on('click', function (e) {
                e.preventDefault();
                jQuery.fancybox(phoneOptionsFancyboxContent, {
                  openEffect: 'elastic',
                  closeEffect: 'elastic'
                });
              });
              return; // Success
            }

            if (footerFancyboxRetryCount < maxFooterFancyboxRetries) {
              footerFancyboxRetryCount++;
              setTimeout(initFooterFancyboxFallback, footerFancyboxRetryDelay);
            }
          };

          // On Odysseus pages, skip qTip (crashes at render time) and use fancybox directly
          if (isOdysseusPage()) {
            setTimeout(initFooterFancyboxFallback, 500);
          } else {
            setTimeout(initFooterQtip, 500);
          }
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyFallback);
      } else {
        // 500ms delay to ensure jQuery, fancybox, and adc-qtip.js have loaded
        // before we attempt to initialize qTip tooltips and fancybox handlers
        setTimeout(applyFallback, 500);
      }
    } catch (e) {
      // no-op
    }
  }

  /**
   * Remove all geo fallback elements and restore normal phone behavior.
   * Called when geolocation.js successfully determines the user's region.
   */
  function removeGeoFallbackMessage () {
    // Set flag to prevent race condition where applyFallback runs after this
    window.__geoFallbackRemoved = true;

    try {
      // =================================================================
      // HEADER (Desktop): Remove qTip link
      // =================================================================
      var fallbackDiv = document.getElementById('geo_fallback_msg');
      if (fallbackDiv) {
        // Destroy qTip if it exists before removing the element
        if (typeof jQuery !== 'undefined') {
          var qtipEl = jQuery(fallbackDiv).find('.my_qtip');
          if (qtipEl.length && qtipEl.qtip) {
            try { qtipEl.qtip('destroy', true); } catch (e) { /* no-op */ }
          }
        }
        fallbackDiv.parentNode.removeChild(fallbackDiv);
      }

      // Remove the extra margin from phone div
      var phoneDiv = document.querySelector('#header #slogan .phone');
      if (phoneDiv) {
        phoneDiv.style.marginBottom = '';
      }

      // =================================================================
      // HEADER (Mobile): Restore phone icon to direct tel: link
      // =================================================================
      var mobilePhoneBtn = document.querySelector('#mobile_phone_link[data-geo-fallback]');
      if (mobilePhoneBtn && typeof jQuery !== 'undefined') {
        // Restore original href before removing the attribute
        var originalMobileHref = mobilePhoneBtn.getAttribute('data-original-href');
        if (originalMobileHref) {
          mobilePhoneBtn.setAttribute('href', originalMobileHref);
        }
        mobilePhoneBtn.removeAttribute('data-geo-fallback');
        mobilePhoneBtn.removeAttribute('data-original-href');
        jQuery(mobilePhoneBtn).off('click.geoFallback');
      }

      // =================================================================
      // FOOTER (Mobile): Restore "Call Us" button to direct tel: link
      // =================================================================
      var footerCallBtn = document.querySelector('#need_help_container .mobile > a[data-geo-fallback]');
      if (footerCallBtn && typeof jQuery !== 'undefined') {
        // Restore original href before removing the attribute
        var originalFooterHref = footerCallBtn.getAttribute('data-original-href');
        if (originalFooterHref) {
          footerCallBtn.setAttribute('href', originalFooterHref);
        }
        footerCallBtn.removeAttribute('data-geo-fallback');
        footerCallBtn.removeAttribute('data-original-href');
        jQuery(footerCallBtn).off('click.geoFallback');
      }

      // =================================================================
      // FOOTER (Desktop): Remove qTip link and associated style
      // =================================================================
      var footerFallbackDiv = document.getElementById('geo_fallback_footer_msg');
      if (footerFallbackDiv) {
        // Destroy qTip if it exists before removing the element
        if (typeof jQuery !== 'undefined') {
          var footerQtipEl = jQuery(footerFallbackDiv).find('.my_qtip');
          if (footerQtipEl.length && footerQtipEl.qtip) {
            try { footerQtipEl.qtip('destroy', true); } catch (e) { /* no-op */ }
          }
        }
        footerFallbackDiv.parentNode.removeChild(footerFallbackDiv);
      }
      var footerFallbackStyle = document.getElementById('geo_fallback_footer_style');
      if (footerFallbackStyle) {
        footerFallbackStyle.parentNode.removeChild(footerFallbackStyle);
      }
    } catch (e) {
      // no-op
    }
  }
  // Make this available globally so geolocation.js can call it
  window.removeGeoFallbackMessage = removeGeoFallbackMessage;
  window.injectGeoFallbackMessage = injectGeoFallbackMessage;

  /**
   * Delete geo cookies (used when functional consent is revoked).
   */
  function deleteGeoCookies () {
    try {
      // helpers.js createCookie writes these on the root domain (domain=.<root>), which a host-only delete
      // does not reach: clear that copy, and any host-only one.
      var hostParts = window.location.hostname.split('.');
      var rootDomain = hostParts.length >= 2 ? '.' + hostParts.slice(-2).join('.') : '';
      ['geoCountryCode', 'geoPhoneOpts'].forEach(function (name) {
        var expired = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        if (rootDomain) document.cookie = expired + '; domain=' + rootDomain;
        document.cookie = expired;
      });
    } catch (e) {
      // no-op
    }
  }

  /**
   * Load geolocation.js for regional phone numbers.
   * Only injects if not already loaded (prevents duplicate API calls).
   */
  function loadGeolocationScript () {
    if (!document.getElementById('geolocation-js') && !window.__geolocationLoaded) {
      window.__geolocationLoaded = true;
      var geoScript = document.createElement('script');
      geoScript.id = 'geolocation-js';
      geoScript.async = true;
      // Relative path on our own hosts (www, dev, local); absolute URL for subdomains (deals, etc.)
      var isMainDomain = window.location.hostname === 'www.americandiscountvacations.com' ||
                         window.location.hostname === 'dev.americandiscountvacations.com' ||
                         window.location.hostname === 'local.americandiscountvacations.com';
      geoScript.src = isMainDomain
        ? '/assets/js/geolocation.js'
        : 'https://www.americandiscountvacations.com/assets/js/geolocation.js';
      geoScript.onerror = function () {
        console.warn('[CookieControl] geolocation.js failed to load');
        window.__geolocationLoaded = false;
        // Show fallback so international users have options
        window.__geoFallbackRemoved = false;
        if (typeof injectGeoFallbackMessage === 'function') {
          injectGeoFallbackMessage();
        }
      };
      (document.head || document.body).appendChild(geoScript);
    }
  }

  /**
   * Check if functional consent has been explicitly granted.
   * @returns {boolean}
   */
  function hasFunctionalConsent () {
    try {
      var match = document.cookie.match(/(?:^|;\s*)CookieControl=([^;]*)/);
      if (match && match[1]) {
        var consent = JSON.parse(decodeURIComponent(match[1]));
        return consent && consent.optionalCookies && consent.optionalCookies.functional === 'accepted';
      }
    } catch (e) {
      // no-op
    }
    return false;
  }

  /**
   * Fetch campaign phone number from API.
   * @param {function} callback - Called with phone number on success, null on failure
   */
  function fetchCampaignPhone (callback, optSource, optCampaign) {
    try {
      var source, campaign;
      if (typeof optSource !== 'undefined') {
        // Use provided params (e.g. from saved session data)
        source = optSource || '';
        campaign = optCampaign || '';
      } else {
        // Read from URL
        var params = getUrlParams(window.location.href);
        source = params.utm_source || '';
        campaign = params.utm_campaign || '';
      }

      var apiPath = 'campaign-phones?source=' + encodeURIComponent(source) +
                    '&campaign=' + encodeURIComponent(campaign) +
                    '&is_mobile=' + isMobileDevice();

      // Use loadUrl if available (your existing helper), otherwise construct URL
      var apiUrl;
      if (typeof window.loadUrl === 'function') {
        apiUrl = window.loadUrl('api', apiPath);
      } else {
        // Fallback - adjust this base URL as needed
        apiUrl = '/api/' + apiPath;
      }

      // Use fetch if available, otherwise XMLHttpRequest
      if (typeof fetch === 'function') {
        fetch(apiUrl, { headers: proxyHeaders(apiUrl) })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var phoneNumber = data && data.data;
            if (typeof phoneNumber === 'string' && phoneNumber.trim().length > 0) {
              callback(phoneNumber.trim());
            } else {
              callback(null);
            }
          })
          .catch(function () {
            callback(null);
          });
      } else {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', apiUrl, true);
        if (isThisOrigin(apiUrl)) {
          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        }
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              try {
                var data = JSON.parse(xhr.responseText);
                var phoneNumber = data && data.data;
                if (typeof phoneNumber === 'string' && phoneNumber.trim().length > 0) {
                  callback(phoneNumber.trim());
                } else {
                  callback(null);
                }
              } catch (e) {
                callback(null);
              }
            } else {
              callback(null);
            }
          }
        };
        xhr.send();
      }
    } catch (e) {
      callback(null);
    }
  }

  // ==========================================================================
  // GEOLOCATION: Initial Phone Number Logic
  // ==========================================================================

  // Track whether UTM-based phone was set (so geolocation.js knows not to override)
  window.__utmPhoneSet = false;

  /**
   * Save UTM campaign data (source, campaign, phone) for cross-page persistence.
   * Uses sessionStorage (primary, synchronous, reliable) with cookie fallback.
   * Not consent-dependent — stores only first-party ad attribution + a business phone number.
   */
  function saveUtmCampaignData (source, campaign, phone) {
    var data = { source: source || '', campaign: campaign || '', phone: phone || '' };
    try {
      sessionStorage.setItem('utmCampaignData', JSON.stringify(data));
    } catch (e) {
      // sessionStorage unavailable
    }
    try {
      var d = new Date();
      d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
      document.cookie = 'utmCampaignData=' + encodeURIComponent(JSON.stringify(data)) +
        '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    } catch (e) {
      // no-op
    }
  }

  /**
   * Read UTM campaign data. Tries sessionStorage first, then cookie.
   * @returns {{ source: string, campaign: string, phone: string }|null}
   */
  function readUtmCampaignData () {
    try {
      var stored = sessionStorage.getItem('utmCampaignData');
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (e) {
      // no-op
    }
    try {
      var match = document.cookie.match(/(?:^|; )utmCampaignData=([^;]*)/);
      if (match && match[1]) {
        var parsed = JSON.parse(decodeURIComponent(match[1]));
        try { sessionStorage.setItem('utmCampaignData', JSON.stringify(parsed)); } catch (e) { /* */ }
        return parsed;
      }
    } catch (e) {
      // no-op
    }
    return null;
  }

  // For returning users with consent and no UTM params: restore phone from cookie immediately
  // This prevents the default US number from flashing briefly before geolocation.js runs
  if (!hasUtmParams() && hasFunctionalConsent()) {
    try {
      var phoneOptsCookie = document.cookie.match(/(?:^|; )geoPhoneOpts=([^;]*)/);
      if (phoneOptsCookie && phoneOptsCookie[1]) {
        var savedPhoneOpts = JSON.parse(decodeURIComponent(phoneOptsCookie[1]));
        // Truthiness is not enough: this value is painted straight into the header,
        // the footer and the tel: links below, so it has to look like a number.
        if (savedPhoneOpts && adcSanitizePhone(savedPhoneOpts.phoneNum)) {
          setDefaultPhoneFields(
            savedPhoneOpts.phoneNum,
            savedPhoneOpts.footerString || ('Dial ' + savedPhoneOpts.phoneNum),
            savedPhoneOpts.footerStringMobile || savedPhoneOpts.phoneNum,
            savedPhoneOpts.mobileCallUsBtn !== false,
            savedPhoneOpts.mobilePhoneLinkFancy === true
          );
        } else {
          removePhoneHideCSS();
        }
      } else {
        removePhoneHideCSS();
      }
    } catch (e) {
      // Cookie parsing failed - geolocation.js will handle it
      removePhoneHideCSS();
    }
  } else {
    removePhoneHideCSS();
  }

  /**
   * #2637: the header's Facebook follow link (.adc-fb-follow) shows our follower count, which
   * adc-api reads from Facebook once a day. No Facebook script runs in the browser, so this
   * needs no consent. It says "Follow us" until a count is known, and stays that way when
   * the call fails.
   */
  function showFacebookFollowers () {
    var targets = document.querySelectorAll('[data-fb-followers]');
    if (!targets.length || typeof fetch !== 'function') return;

    var apiUrl = typeof window.loadUrl === 'function'
      ? window.loadUrl('api', 'social/facebook-followers')
      : '/api/social/facebook-followers'; // as the campaign phone lookup falls back, keeping the page's own environment

    try {
      fetch(apiUrl, { credentials: 'omit', headers: proxyHeaders(apiUrl) })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (body) {
          var display = body && body.data && body.data.display;
          if (typeof display !== 'string' || display.trim() === '') return;
          for (var i = 0; i < targets.length; i++) {
            targets[i].textContent = display.trim() + ' followers';
          }
        })
        .catch(function () {
          // no-op: the link keeps "Follow us"
        });
    } catch (e) {
      // no-op
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showFacebookFollowers);
  } else {
    showFacebookFollowers();
  }

  var savedCampaign = readUtmCampaignData();

  if (hasUtmParams()) {
    // UTM params present - fetch campaign phone
    // Set flag immediately so geolocation.js knows not to override
    window.__utmPhoneSet = true;

    // Decorate all internal links so UTM params carry to subsequent pages
    decorateLinksWithUtm();

    // Save UTM params to cookie/sessionStorage as backup
    var urlParams = getUrlParams(window.location.href);
    var utmSource = urlParams.utm_source || '';
    var utmCampaign = urlParams.utm_campaign || '';
    saveUtmCampaignData(utmSource, utmCampaign, '');

    // Show US/Canada toll-free immediately as placeholder while fetching
    setDefaultPhoneFields(
      '1-855-602-7447',
      'Call us Toll Free at 1-855-602-7447',
      'Toll Free for US & Canada',
      true,
      false
    );

    fetchCampaignPhone(function (campaignPhone) {
      if (campaignPhone) {
        // Got a campaign-specific phone - use it
        setDefaultPhoneFields(
          campaignPhone,
          'Call us Toll Free at ' + campaignPhone,
          'Toll Free for US & Canada',
          true,
          false
        );
        window.__utmPhoneSet = true;
        // Update cookie with the actual campaign phone
        saveUtmCampaignData(utmSource, utmCampaign, campaignPhone);
      }
    });
  } else if (savedCampaign) {
    // No UTM params in URL, but we have saved campaign data from a previous page
    window.__utmPhoneSet = true;

    if (savedCampaign.phone) {
      // We already have the campaign phone - display it immediately
      setDefaultPhoneFields(
        savedCampaign.phone,
        'Call us Toll Free at ' + savedCampaign.phone,
        'Toll Free for US & Canada',
        true,
        false
      );
    } else {
      // Cookie was saved before API returned - show placeholder and re-fetch
      setDefaultPhoneFields(
        '1-855-602-7447',
        'Call us Toll Free at 1-855-602-7447',
        'Toll Free for US & Canada',
        true,
        false
      );
      fetchCampaignPhone(function (campaignPhone) {
        if (campaignPhone) {
          setDefaultPhoneFields(
            campaignPhone,
            'Call us Toll Free at ' + campaignPhone,
            'Toll Free for US & Canada',
            true,
            false
          );
          saveUtmCampaignData(savedCampaign.source, savedCampaign.campaign, campaignPhone);
        }
      }, savedCampaign.source, savedCampaign.campaign);
    }
  } else if (!hasFunctionalConsent()) {
    // No UTM params and no functional consent
    // Show US/Canada toll-free (fallback will be injected via onRevoke if user declines)
    setDefaultPhoneFields(
      '1-855-602-7447',
      'Call us Toll Free at 1-855-602-7447',
      'Toll Free for US & Canada',
      true,
      false
    );

    // Delete any stale geo cookies from before consent was revoked
    deleteGeoCookies();
  }
  // If functional consent IS granted (and no UTM), geolocation.js will handle it

  // Site Search 360 (SS360)
  // Goal:
  // - Search works for everyone (scripts always load)
  // - Tracking/logging OFF by default
  // - Tracking/logging ON only after Analytics consent (see Analytics onAccept/onRevoke)
  (function initSiteSearch360 () {
    function getCookieValueSimple (name) {
      try {
        const m = document.cookie.match(
          new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
        );
        return m ? decodeURIComponent(m[1]) : null;
      } catch (e) {
        return null;
      }
    }

    function setSs360TrackingCookie (val) {
      try {
        document.cookie = 'ss360-tracking=' + String(val) + '; path=/; max-age=31536000; SameSite=Lax';
      } catch (e) {
        // no-op
      }
    }

    // Decide initial tracking state:
    // - If GPC is on: always OFF
    // - Else: honor previously saved CookieControl consent (analytics accepted => ON)
    let desired = 0;

    if (!HAS_GPC) {
      try {
        const raw = getCookieValueSimple('CookieControl');
        if (raw) {
          const cc = JSON.parse(raw);
          if (cc && cc.optionalCookies && cc.optionalCookies.analytics === 'accepted') {
            desired = 1;
          }
        }
      } catch (e) {
        // no-op
      }
    }

    setSs360TrackingCookie(desired);

    // Prevent duplicate injections
    if (
      document.getElementById('ss360-local') ||
      document.getElementById('ss360-cdn')
    ) {
      return;
    }

    const head = document.head || document.getElementsByTagName('head')[0] || document.body;
    if (!head) return;

    // 1) Local config/bootstrap (ADV config file)
    const local = document.createElement('script');
    local.id = 'ss360-local';
    // Relative path on our own hosts (www, dev, local); absolute URL for subdomains (deals, etc.)
    var isMainDomain = window.location.hostname === 'www.americandiscountvacations.com' ||
                       window.location.hostname === 'dev.americandiscountvacations.com' ||
                       window.location.hostname === 'local.americandiscountvacations.com';
    local.src = isMainDomain
      ? '/assets/plugins/ss360/ss360-config.js'
      : 'https://www.americandiscountvacations.com/assets/plugins/ss360/ss360-config.js';

    function injectCdn () {
      // 2) SS360 CDN loader (v13)
      const cdn = document.createElement('script');
      cdn.id = 'ss360-cdn';
      cdn.async = true;
      cdn.src = 'https://cdn.sitesearch360.com/v13/sitesearch360-v13.min.js';
      head.appendChild(cdn);
    }

    local.onload = injectCdn;
    local.onerror = injectCdn;
    head.appendChild(local);
  })();

  // Load Cookie Control library
  const cookieControlScript = document.createElement('script');
  cookieControlScript.async = true;
  cookieControlScript.src = 'https://cc.cdn.civiccomputing.com/9/cookieControl-9.10.1.min.js';
  cookieControlScript.onload = function () {
    // Ensure Clarity exists, then start in fully denied mode (Consent Mode v2)
    if (typeof window.clarity !== 'function') {
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
    }
    // Global default: deny everything until we decide otherwise by region
    window.clarity('consentv2', {
      ad_storage: 'denied',
      analytics_storage: 'denied'
    });

    // Google Consent Mode v2 (GA4 / Google Ads): establish gtag + dataLayer and
    // default-deny BEFORE any Google tag can load. Google tags are still only
    // injected after acceptance (load-after-accept); this adds an explicit
    // denied-by-default consent signal so any Google tag present respects it,
    // and is flipped to 'granted' in the analytics/advertising onAccept handlers.
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });

    // Base Cookie Control configuration (shared)
    const baseConfig = {
      // apiKey: '592b99ebdf88c091dad9b556b6d8de236ac97687', // for local testing (from docs)
      apiKey: CIVIC_API_KEY, // ADV
      product: 'PRO_MULTISITE',

      // v9 default is "accept all". Keep v8-style behavior where "Accept" = only recommended.
      acceptBehaviour: 'recommended',

      necessaryCookies: [
        'CookieControl',
        'api_token',
        'Ody*',
        'ODY*',
        'ody*',
        'ASP.NET_SessionId',
        'ss360-tracking',

        // referrer-capture.js operational switches (feature-state only, no
        // personal data). The kill/opt-out (adc_src_off) MUST always persist so
        // an opt-out is never silently lost; the canary force-on (adc_src_on)
        // likewise. These only toggle the feature's code path and do NOT make
        // the attribution cookie adc_src necessary: referrer-capture.js only
        // writes adc_src once advertising consent is granted (its on-load consent
        // gate + the advertising onAccept hook), and Cookie Control still CLEARS
        // it if advertising is later revoked -- so force-on can never keep
        // adc_src alive in a gated region.
        'adc_src_off',
        'adc_src_on'
      ],
      text: {
        title: 'Our site uses cookies to store information on your computer.',
        intro: withGpcText('We use cookies to optimize site functionality and give you the best possible experience.'),
        notifyTitle: 'Our site uses cookies to store information on your computer.',
        notifyDescription: withGpcText('We use cookies to optimize site functionality and give you the best possible experience.')
      },
      statement: {
        description: 'For more information view our',
        name: 'Privacy Policy',
        url: 'https://www.americandiscountvacations.com/privacy',
        updated: '08/01/2026' // dd/mm/yyyy
      },
      ccpaConfig: {
        description: withGpcText(
          'This may include the website or our third-party tools processing personal information. ' +
          'You may opt out of such activity by using the button below. To find out more about the ' +
          'categories of personal information collected and the purposes for which such information ' +
          'will be used, please refer to our'),
        name: 'Personal Information Policy',
        url: 'https://www.americandiscountvacations.com/privacy#ccpa',
        updated: '08/01/2026', // dd/mm/yyyy
        rejectButton: 'Do Not Sell or Share My Personal Information'
      },
      logConsent: true,
      optionalCookies: [
        {
          name: 'analytics',
          label: 'Analytical Cookies',
          description: 'Analytical cookies help us to improve our website by collecting and reporting information on its usage.',
          cookies: [
            '_ga',
            '_ga_*',
            '_gid',
            '_gat',
            '__utma',
            '__utmt',
            '__utmb',
            '__utmc',
            '__utmz',
            '__utmv',

            // Microsoft Clarity
            '_clck',
            '_clsk'
          ],
          // v9 key
          recommendedState: true,
          onAccept: function () {
            // While GPC is on nothing here loads, and switching this category on is undone (see revokeForGpc)
            if (HAS_GPC) {
              revokeForGpc('analytics');
              return;
            }
            // Block if in CCPA mode without existing consent
            if (window.__ccpaBlockOnAccept) {
              return;
            }

            loadCloudflareWebAnalytics();

            // Booking pages: tell the consent preload (orig-adc assets/js/adc-consent-preload.js), when the page has
            // it, that Analytics was accepted, so Flex Pay's page-view hits are no longer held back
            if (typeof window.adcSetUpliftTrackingConsent === 'function') {
              window.adcSetUpliftTrackingConsent(true);
            }

            // Microsoft Clarity - grant consent and load script
            if (typeof window.clarity === 'function') {
              window.clarity('consentv2', {
                analytics_storage: 'granted'
              });
            }

            window['ga-disable-G-ZFSQKB1TFJ'] = false;

            // SS360 tracking/logging: enable only after Analytics consent (unless GPC)
            if (!HAS_GPC) {
              try {
                document.cookie = 'ss360-tracking=1; path=/; max-age=31536000; SameSite=Lax';
              } catch (e) {
                // no-op
              }
            }

            // Add Google Analytics (GA4)
            window.dataLayer = window.dataLayer || [];
            window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

            // Google Consent Mode v2: analytics consent granted
            window.gtag('consent', 'update', {
              analytics_storage: 'granted'
            });

            window.gtag('js', new Date());
            if (!window.__gaConfigured) {
              window.__gaConfigured = true;
              window.gtag('config', 'G-ZFSQKB1TFJ');
            }

            if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js?id=G-ZFSQKB1TFJ"]')) {
              const f = document.getElementsByTagName('script')[0];
              const j = document.createElement('script');
              j.async = true;
              j.src = 'https://www.googletagmanager.com/gtag/js?id=G-ZFSQKB1TFJ';
              f.parentNode.insertBefore(j, f);
            }

            // `odysseusData` is a variable hosted by Odysseus.
            // See PR https://github.com/americandiscount/newadc/issues/1116 for a description on how it works.
            if (typeof odysseusData === 'object' && Object.keys(odysseusData).length > 0) {
              // Google Analytics purchase event (confirmation page only)
              // Guard so this cannot fire twice if analytics is re-accepted later
              if (!window.__gaPurchaseSent) {
                window.__gaPurchaseSent = true;

                try {
                  window.gtag('event', 'purchase', {
                    transaction_id: odysseusData.confirmationNumber,
                    value: odysseusData.totalFare,
                    net_commission: odysseusData.cruiseNetCommPostRules,
                    cruise_line_name: odysseusData.cruiseLineName,
                    referring_site: odysseusData.referrer1 || '',
                    currency: odysseusData.currency,
                    items: [
                      {
                        item_id: odysseusData.confirmationNumber,
                        item_name: odysseusData.cruiseLineName,
                        affiliation: odysseusData.siteItemName || '',
                        coupon: odysseusData.promo1 || '',
                        discount: odysseusData.discount || 0,
                        item_brand: odysseusData.cruiseShipName,
                        item_category: odysseusData.cruiseDestination || '',
                        item_category2: odysseusData.duration || '',
                        item_category3: odysseusData.roomType || '',
                        item_category4: odysseusData.roomCategory || '',
                        item_category5: odysseusData.departureDate || '',
                        item_variant: odysseusData.fareCode || '',
                        price: odysseusData.baseFare,
                        net_commission: odysseusData.cruiseNetCommPostRules,
                        quantity: 1
                      }
                    ]
                  });
                } catch (e) {
                  // no-op
                }
              }
            }
            // End Google Analytics

            // Load Microsoft Clarity script (guarded)
            if (!document.querySelector('script[src*="clarity.ms/tag/"]')) {
              (function (c, l, a, r, i, t, y) {
                c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
                t = l.createElement(r);
                t.async = 1;
                t.src = 'https://www.clarity.ms/tag/' + i;
                y = l.getElementsByTagName(r)[0];
                y.parentNode.insertBefore(t, y);
              })(window, document, 'clarity', 'script', 'pfhj35tmhg');
            }
            // End Microsoft Clarity
          },
          onRevoke: function () {
            // Booking pages: hold Flex Pay's page-view hits back again (orig-adc assets/js/adc-consent-preload.js)
            if (typeof window.adcSetUpliftTrackingConsent === 'function') {
              window.adcSetUpliftTrackingConsent(false);
            }

            // SS360 tracking/logging: disable when Analytics is revoked
            try {
              document.cookie = 'ss360-tracking=0; path=/; max-age=31536000; SameSite=Lax';
            } catch (e) {
              // no-op
            }

            // Disable Google Analytics
            window['ga-disable-G-ZFSQKB1TFJ'] = true;
            // End Google Analytics

            // Google Consent Mode v2: analytics consent withdrawn
            if (typeof window.gtag === 'function') {
              window.gtag('consent', 'update', {
                analytics_storage: 'denied'
              });
            }

            // User revoked consent -> disable Clarity again
            if (typeof window.clarity === 'function') {
              window.clarity('consentv2', { analytics_storage: 'denied' });
            }
          }
        },
        {
          name: 'advertising',
          label: 'Advertising Cookies',
          description: 'Advertising cookies help us show ads and measure ad performance.',
          cookies: [
            // Google / AdSense related
            'IDE',
            'test_cookie',
            'ANID',
            'NID',
            '1P_JAR',
            '__gads',
            '__gpi',
            '_gcl_au',

            // Microsoft Ads (UET) related
            'MUID',
            '_uetmsclkid',
            '_uetsid',
            '_uetvid',

            // Meta / Facebook related
            '_fbp',
            '_fbc',
            'fr',
            '_js_reg_ext_ref',
            '_js_reg_fb_ref',
            'datr',

            // ADV first-party cross-affiliate booking-source attribution
            // (set/read by assets/js/referrer-capture.js). Registered here so
            // Civic's auto-blocking doesn't delete it. Persistence follows this
            // file's per-region consent state: kept by default only in
            // unregulated US regions; gated (kept only on opt-in) in EU/UK/BR
            // (GDPR) AND in California/CCPA, where the CCPA branch forces all
            // optional categories OFF by default. Without this entry the cookie
            // is wiped on every load and never persists.
            'adc_src'
          ],
          recommendedState: true,
          onAccept: function () {
            // While GPC is on nothing here loads, and switching this category on is undone (see revokeForGpc)
            if (HAS_GPC) {
              revokeForGpc('advertising');
              return;
            }
            // Block if in CCPA mode without existing consent
            if (window.__ccpaBlockOnAccept) {
              return;
            }

            // Advertising consent is now granted, so (re)capture the ad source into
            // adc_src. This is the path that captures on a brand-new session, where
            // referrer-capture.js's on-load capture is consent-gated and no-ops until
            // now. No-op unless this load was a genuine arrival (URL carried
            // saveReferrer). See assets/js/referrer-capture.js.
            //
            // The typeof guard is safe against load order: referrer-capture.js loads
            // immediately after cookie-control.js, and this onAccept is async (fires
            // after Civic resolves consent), so the function is defined by the time we
            // reach here. In the pathological case where it is not, referrer-capture's
            // own on-load consent-gated capture is the fallback -- consent is now
            // established, so its advertisingConsented() gate captures when it executes.
            if (typeof window.__adcRunReferrerCapture === 'function') {
              window.__adcRunReferrerCapture();
            }

            // Update Clarity consent state before loading advertising scripts
            if (typeof window.clarity === 'function') {
              window.clarity('consentv2', {
                ad_storage: 'granted'
              });
            }

            // Google Consent Mode v2: advertising consent granted (before ad tags load)
            if (typeof window.gtag === 'function') {
              window.gtag('consent', 'update', {
                ad_storage: 'granted',
                ad_user_data: 'granted',
                ad_personalization: 'granted'
              });
            }

            // Add Microsoft Ads (UET)
            if (!document.querySelector('script[src*="bat.bing.com/bat.js"]')) {
              (function (w, d, t, r, u) {
                w[u] = w[u] || [];
                const f = function () {
                  const o = { ti: '28480396', enableAutoSpaTracking: true };
                  o.q = w[u];
                  w[u] = new UET(o);
                  w[u].push('pageLoad');
                };
                const n = d.createElement(t);
                n.src = r;
                n.async = 1;
                n.onload = n.onreadystatechange = function () {
                  const s = this.readyState;
                  (s && s !== 'loaded' && s !== 'complete') || (f(), n.onload = n.onreadystatechange = null);
                };
                const i = d.getElementsByTagName(t)[0];
                i.parentNode.insertBefore(n, i);
              })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
            }
            // Explicit UET consent grant. UET is not governed by Google Consent
            // Mode, so this re-enables it after a same-page revoke + re-accept.
            window.uetq = window.uetq || [];
            window.uetq.push('consent', 'update', { ad_storage: 'granted' });
            // End Microsoft Ads

            // Add FB Tracking Pixel
            !(function (f, b, e, v, n, t, s) {
              if (f.fbq) return;
              n = f.fbq = function () {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
              };
              if (!f._fbq) f._fbq = n;
              n.push = n;
              n.loaded = !0;
              n.version = '2.0';
              n.queue = [];
              t = b.createElement(e);
              t.async = !0;
              t.src = v;
              s = b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t, s);
            })(window, document, 'script', '//connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1731415217095103');
            // Explicit FB consent grant. Covers a same-page re-accept after a
            // prior revoke; Consent Mode v2 governs Google tags, not the FB pixel.
            fbq('consent', 'grant');
            fbq('track', 'PageView');
            // End FB Tracking Pixel

            if (typeof odysseusData === 'object' && Object.keys(odysseusData).length > 0) {
              // Microsoft Ads revenue push
              window.uetq = window.uetq || [];
              window.uetq.push('event', '', { revenue_value: odysseusData.cruiseNetCommPostRules, currency: 'USD' });
              // End Microsoft Ads Conversion

              // Add FB Tracking Pixel (for initial confirmation page)
              fbq('track', 'Purchase', { value: odysseusData.totalFare, currency: 'USD' });
              // End FB Tracking Pixel
            }
            // Add Google Ads Conversion (confirmation page only)
            if (typeof odysseusData === 'object' && Object.keys(odysseusData).length > 0) {
              if (!document.getElementById('google-ads-conversion-js')) {
                const adwordsScript = document.createElement('script');
                adwordsScript.id = 'google-ads-conversion-js';
                adwordsScript.src = 'https://www.googleadservices.com/pagead/conversion.js';
                document.body.appendChild(adwordsScript);
              }
            }
            // Add Shopper Approved Purchase Review (for initial confirmation page)
            // `sa_values` is a variable hosted by Odysseus.
            // See PR https://github.com/americandiscount/newadc/issues/1116 for a description on how it works.
            if (typeof odysseusData === 'object' && Object.keys(odysseusData).length > 0 && typeof (sa_values) !== 'undefined') {
              function saLoadScript (src) {
                const js = window.document.createElement('script');
                js.src = src;
                js.type = 'text/javascript';
                document.getElementsByTagName('head')[0].appendChild(js);
              }
              const d = new Date();
              if (d.getTime() - 172800000 > 1450368383000) saLoadScript('//www.shopperapproved.com/thankyou/rate/16748.js');
              else saLoadScript('//direct.shopperapproved.com/thankyou/rate/16748.js?d=' + d.getTime());
            }
            // End Shopper Approved Purchase Review

            // Cruise Critic pixel (if provided globally)
            if (typeof pixelChecker === 'function') {
              // eslint-disable-next-line no-undef
              pixelChecker();
            }
          }, // closes onAccept function

          onRevoke: function () {
            if (typeof window.clarity === 'function') {
              window.clarity('consentv2', { ad_storage: 'denied' });
            }

            // Google Consent Mode v2: advertising consent withdrawn
            if (typeof window.gtag === 'function') {
              window.gtag('consent', 'update', {
                ad_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied'
              });
            }

            // Stop the already-loaded ad pixels from firing further on this page.
            // Consent Mode v2 governs Google tags only; UET and the FB pixel keep
            // running in-memory until told otherwise, so signal each vendor
            // directly (avoids a forced page reload).
            if (typeof window.fbq === 'function') {
              window.fbq('consent', 'revoke');
            }
            if (window.uetq && typeof window.uetq.push === 'function') {
              window.uetq.push('consent', 'update', { ad_storage: 'denied' });
            }
          }
        },

        // Functional cookies (LiveChat + Geolocation)
        {
          name: 'functional',
          label: 'Functional Cookies',
          description: 'Functional cookies enable features like live chat and regional phone number display. This feature may also use browser storage to maintain chat sessions.',
          cookies: [
            // LiveChat
            'lc_cid',
            'lc_cst',
            // Geolocation (phone number regionalization)
            'geoCountryCode',
            'geoPhoneOpts'
          ],
          recommendedState: true,
          onAccept: function () {
            // Block if in CCPA mode without existing consent
            if (window.__ccpaBlockOnAccept) {
              return;
            }

            // If user re-accepts, remove any "hide LiveChat" CSS we injected on revoke
            const style = document.getElementById('cc-hide-livechat');
            if (style && style.parentNode) style.parentNode.removeChild(style);

            // Re-shows the widget after a revoke hid it. LiveChat API: after "hide" you must use
            // "minimize" or "maximize" to show again. Only a hidden widget is touched: this handler
            // runs on every page load, and an unconditional minimize also collapsed a chat the
            // visitor had open (#4312).
            const showLiveChatIfHidden = function () {
              try {
                const state = window.LiveChatWidget.get('state');
                if (state && state.visibility === 'hidden') {
                  window.LiveChatWidget.call('minimize');
                }
              } catch (e) {
                // Getters throw until the widget has loaded; the ready handler below covers that
              }
            };

            // Best effort: re-show the widget if it's already loaded
            if (window.LiveChatWidget && typeof window.LiveChatWidget.call === 'function') {
              showLiveChatIfHidden();
            }

            // LiveChat widget
            try {
              // Compute Day/Hour session vars
              const date = new Date();
              const timezone = 'America/New_York';
              const optionsDay = { weekday: 'long', timeZone: timezone };
              const optionsHour = { hour: 'numeric', timeZone: timezone };

              // Use en-US / en-GB for locale formatting
              const cbday = date.toLocaleDateString('en-US', optionsDay);
              const cbhour = Number(date.toLocaleString('en-GB', optionsHour));

              window.__lc = window.__lc || {};
              window.__lc.license = 19041711;

              // Ensure LiveChatWidget stub exists (do not recreate if already present)
              if (!window.LiveChatWidget) {
                (function (n, t, c) {
                  function i (n) { return e._h ? e._h.apply(null, n) : e._q.push(n); }
                  var e = {
                    _q: [],
                    _h: null,
                    _v: '2.0',
                    on: function () { i(['on', c.call(arguments)]); },
                    once: function () { i(['once', c.call(arguments)]); },
                    off: function () { i(['off', c.call(arguments)]); },
                    get: function () {
                      if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
                      return i(['get', c.call(arguments)]);
                    },
                    call: function () { i(['call', c.call(arguments)]); },
                    init: function () {
                      // Guard against injecting tracking.js more than once
                      if (t.querySelector('script[src="https://cdn.livechatinc.com/tracking.js"]')) return;

                      const s = t.createElement('script');
                      s.async = true;
                      s.type = 'text/javascript';
                      s.src = 'https://cdn.livechatinc.com/tracking.js';
                      t.head.appendChild(s);
                    }
                  };

                  e.init();
                  n.LiveChatWidget = e;
                }(window, document, [].slice));
              } else {
                // If widget stub exists but script is missing, (re)inject it
                if (!document.querySelector('script[src="https://cdn.livechatinc.com/tracking.js"]') &&
                    window.LiveChatWidget && typeof window.LiveChatWidget.init === 'function') {
                  try { window.LiveChatWidget.init(); } catch (e) { /* no-op */ }
                }
              }

              // adc-api#2637: the page the customer is on, for the ChatBot. Origin and path only: the query
              // string carries tracking ids and booking references. Swift pages move between sailings
              // without a page load, so once the widget is ready the path is checked every second.
              // Nothing is sent without functional consent: onRevoke only hides the widget, which stays
              // loaded, so the ready callback and the watcher both check consent before sending.
              function currentPageUrl () {
                // A path can carry a secret: the password reset page is /auth/reset_password/<uid>/<hash>.
                // Anything under /auth/ is cut to its first two segments, and any other segment of 16 or
                // more letters or digits with no hyphen is redacted as a possible token, so neither reaches
                // LiveChat. Sailing slugs (1677390--7-night-...) are kept: the ChatBot reads the PackageID.
                let segments = window.location.pathname.split('/');
                if (segments[1] === 'auth') segments = segments.slice(0, 3);
                const path = segments.map(function (segment) {
                  return /^[a-z0-9]{16,}$/i.test(segment) ? ':redacted' : segment;
                }).join('/');
                return window.location.origin + path;
              }

              // adc-api#2637: the phone number the page shows, so the ChatBot gives the same one. The
              // campaign and geolocation paths both end by writing it into #header_main_phone, which
              // this reads rather than working the number out again; a page without that header falls
              // back to the first .js-contact-us link that shows a number, since a link can be empty
              // until the page fills it. adc-api uses it only when it is a number we publish.
              function currentContactPhone () {
                const header = document.getElementById('header_main_phone');
                const candidates = header ? [header] : Array.prototype.slice.call(document.querySelectorAll('.js-contact-us'));

                for (let i = 0; i < candidates.length; i++) {
                  const phone = (candidates[i].textContent || '').trim();

                  if (/\d/.test(phone)) return phone;
                }

                return '';
              }

              // adc-api#2833: the sailing on an Odysseus booking page. The category, staterooms and checkout
              // pages' URLs carry only a booking reference, which the path above leaves out, so the ChatBot
              // could not tell which cruise the customer was booking. Odysseus sets the sailing's PackageID on
              // those pages as odyUI.packageId; it is read, never changed, and only a positive whole number is sent.
              // Empty on every other page, so a value never outlives the page it came from: Odysseus's
              // template sets it to 0 off the booking pages, which is not a sailing.
              function currentPackageId () {
                const ody = window.odyUI;
                const id = ody && ody.packageId !== undefined && ody.packageId !== null ? String(ody.packageId) : '';

                return /^[1-9]\d{0,9}$/.test(id) ? id : '';
              }

              // Send the page, once consent allows. The first send is the full set (set_session_variables
              // replaces it); later ones merge in page_url and contact_phone with update_session_variables,
              // which keeps Day, Hour and site_origin. The last values sent are kept on window, since
              // consent can be accepted more than once on a page and each accept runs this code again. The
              // phone is watched like the path: a campaign number can arrive after the widget is ready.
              function sendPageContext () {
                if (!hasFunctionalConsent()) return;

                const pageUrl = currentPageUrl();
                const contactPhone = currentContactPhone();
                const packageId = currentPackageId();

                if (
                  pageUrl === window.__chatPageUrlSent &&
                  contactPhone === window.__chatContactPhoneSent &&
                  packageId === window.__chatPackageIdSent
                ) return;

                try {
                  if (window.__chatPageUrlSent) {
                    window.LiveChatWidget.call('update_session_variables', { page_url: pageUrl, contact_phone: contactPhone, page_package_id: packageId });
                  } else {
                    window.LiveChatWidget.call('set_session_variables', { Day: cbday, Hour: cbhour, site_origin: 'adv', page_url: pageUrl, contact_phone: contactPhone, page_package_id: packageId });
                  }
                  window.__chatPageUrlSent = pageUrl;
                  window.__chatContactPhoneSent = contactPhone;
                  window.__chatPackageIdSent = packageId;
                } catch (e) {
                  // no-op
                }
              }

              function onReady () {
                sendPageContext();

                // Watch only once; the watcher also resumes sending after a revoke and re-accept.
                if (!window.__chatPageUrlWatch) {
                  window.__chatPageUrlWatch = window.setInterval(sendPageContext, 1000);
                }
              }

              try {
                window.LiveChatWidget.once('ready', onReady);
              } catch (e) {
                // no-op
              }

              // If widget was previously hidden via Cookie Control toggle,
              // ensure it reappears once LiveChat is fully ready
              try {
                window.LiveChatWidget.once('ready', showLiveChatIfHidden);
              } catch (e) {
                // no-op
              }
            } catch (e) {
              // no-op
            }

            // =================================================================
            // GEOLOCATION: Load geolocation.js for regional phone numbers
            // =================================================================
            // Only inject if not already loaded (prevents duplicate API calls)
            // =================================================================
            if (!window.__geolocationLoaded) {
              // Set flag immediately to prevent race condition with 500ms fallback timer
              window.__geoFallbackRemoved = true;
              // Also remove fallback message now if it exists
              removeGeoFallbackMessage();
              loadGeolocationScript();
            }
          },
          onRevoke: function () {
            // =================================================================
            // LIVECHAT: Hide widget (do NOT shutdown)
            // =================================================================
            try {
              // 1) Ask LiveChat to hide (visual), do NOT shutdown
              if (window.LiveChatWidget && typeof window.LiveChatWidget.call === 'function') {
                try { window.LiveChatWidget.call('hide'); } catch (e) { /* no-op */ }
                // Intentionally avoid calling 'shutdown' so the widget can be re-enabled after consent is granted without a page reload.
              }

              // 2) Hard fallback: hide the UI immediately via CSS
              const styleId = 'cc-hide-livechat';
              const existing = document.getElementById(styleId);
              if (!existing) {
                const style = document.createElement('style');
                style.id = styleId;
                style.type = 'text/css';
                style.appendChild(document.createTextNode(
                  [
                    '#chat-widget-container { display: none !important; }',
                    'iframe[src*="livechatinc.com"] { display: none !important; }',
                    'iframe[src*="secure.livechatinc.com"] { display: none !important; }',
                    'iframe[src*="livechat"] { display: none !important; }'
                  ].join('\n')
                ));
                document.head.appendChild(style);
              }

              // 3) Intentionally do NOT remove tracking.js here; removing it would prevent the chat widget
              //    from being re-shown without a full page refresh after consent is granted again.
            } catch (e) {
              // no-op
            }

            // =================================================================
            // GEOLOCATION: Clean up and reset to default phone number
            // =================================================================
            try {
              // 1) Delete geo cookies to honor the user's revocation
              deleteGeoCookies();

              // 2) Remove the geolocation.js script element so it can be re-injected
              var geoScript = document.getElementById('geolocation-js');
              if (geoScript) {
                geoScript.parentNode.removeChild(geoScript);
              }

              // 3) Reset flags so geolocation.js can be re-injected if consent is granted again
              window.__geolocationLoaded = false;
              window.__geoFallbackRemoved = false;

              // 4) Reset phone number based on UTM state
              //    UTM phone numbers are first-party and should persist.
              var savedCampaign = readUtmCampaignData();
              if (hasUtmParams()) {
                // UTM params in URL — re-fetch campaign phone
                window.__utmPhoneSet = true;
                var revokeUrlParams = getUrlParams(window.location.href);
                setDefaultPhoneFields(
                  '1-855-602-7447',
                  'Call us Toll Free at 1-855-602-7447',
                  'Toll Free for US & Canada',
                  true,
                  false
                );
                fetchCampaignPhone(function (campaignPhone) {
                  if (campaignPhone) {
                    setDefaultPhoneFields(
                      campaignPhone,
                      'Call us Toll Free at ' + campaignPhone,
                      'Toll Free for US & Canada',
                      true,
                      false
                    );
                    saveUtmCampaignData(
                      revokeUrlParams.utm_source || '',
                      revokeUrlParams.utm_campaign || '',
                      campaignPhone
                    );
                  }
                });
              } else if (savedCampaign) {
                // No UTM params but saved campaign data — restore or re-fetch
                window.__utmPhoneSet = true;
                if (savedCampaign.phone) {
                  setDefaultPhoneFields(
                    savedCampaign.phone,
                    'Call us Toll Free at ' + savedCampaign.phone,
                    'Toll Free for US & Canada',
                    true,
                    false
                  );
                } else {
                  setDefaultPhoneFields(
                    '1-855-602-7447',
                    'Call us Toll Free at 1-855-602-7447',
                    'Toll Free for US & Canada',
                    true,
                    false
                  );
                  fetchCampaignPhone(function (campaignPhone) {
                    if (campaignPhone) {
                      setDefaultPhoneFields(
                        campaignPhone,
                        'Call us Toll Free at ' + campaignPhone,
                        'Toll Free for US & Canada',
                        true,
                        false
                      );
                      saveUtmCampaignData(savedCampaign.source, savedCampaign.campaign, campaignPhone);
                    }
                  }, savedCampaign.source, savedCampaign.campaign);
                }
              } else {
                // No UTM context — reset to default US/Canada toll-free
                setDefaultPhoneFields(
                  '1-855-602-7447',
                  'Call us Toll Free at 1-855-602-7447',
                  'Toll Free for US & Canada',
                  true,
                  false
                );
              }

              // 5) Always show fallback message since geolocation is now disabled
              //    International users need this to find their regional number,
              //    even when a UTM phone (US/CA) is displayed.
              injectGeoFallbackMessage();
            } catch (e) {
              // no-op
            }
          }
        },

        {
          name: 'socialsharing',
          label: 'Social Sharing Cookies',
          description: 'We use some social sharing plugins, to allow you to share certain pages of our website on social media (for example, on X).',
          cookies: [
            // X (Twitter) widgets
            '_twitter_sess',
            'guest_id',
            'personalization_id',
            'ct0',
            'twid'
          ],
          recommendedState: true,
          onAccept: function () {
            // While GPC is on nothing here loads, and switching this category on is undone (see revokeForGpc)
            if (HAS_GPC) {
              revokeForGpc('socialsharing');
              return;
            }
            // Block if in CCPA mode without existing consent
            if (window.__ccpaBlockOnAccept) {
              return;
            }

            // Ensure the social elements are visible when enabled. Facebook has no widget
            // here: Meta retired the Like button plugin for other websites on 2026-02-10, and
            // the header's plain follow link (.adc-fb-follow) needs no consent.
            const twitterBtn = document.querySelector('.twitter-follow-button');
            if (twitterBtn) twitterBtn.style.display = '';

            // The widget renders only when this code says so, and only while this consent
            // stands: X's widgets.js loads with autoload off, so it does not scan the page on
            // its own when it finishes loading. Otherwise a revoke landing before it loads is
            // undone by that scan, rendering the widget after the visitor opted out. onRevoke
            // clears __adcSocialConsent.
            window.__adcSocialConsent = true;

            var renderX = function () {
              try {
                if (window.__adcSocialConsent && window.twttr && window.twttr.widgets && typeof window.twttr.widgets.load === 'function') {
                  window.twttr.widgets.load();
                }
              } catch (e) {
                // no-op
              }
            };

            // Add X (Twitter) Follow Button, with automatic rendering off (see above)
            // Reuse a tag already on the page, whatever it says, so it cannot leave autoload on.
            let autoload = document.querySelector('meta[name="twitter:widgets:autoload"]');
            if (!autoload) {
              autoload = document.createElement('meta');
              autoload.name = 'twitter:widgets:autoload';
              document.head.appendChild(autoload);
            }
            autoload.content = 'off';

            (function (d, s, id) {
              const existing = d.getElementById(id);
              if (existing) {
                // Added earlier and possibly still loading: render when it finishes. If it has
                // already loaded, the renderX() below covers it.
                existing.addEventListener('load', renderX);
                return;
              }

              const js = d.createElement(s);
              js.id = id;
              js.async = true;
              js.src = 'https://platform.twitter.com/widgets.js';
              js.onload = renderX;

              const fjs = d.getElementsByTagName(s)[0];
              fjs.parentNode.insertBefore(js, fjs);
            })(document, 'script', 'twitter-wjs');

            // Already loaded (a re-accept after a revoke): render now
            renderX();
            // End Twitter Follow Button
          },
          onRevoke: function () {
            try {
              // Stops any render still to come: the SDKs' load callbacks check this flag
              window.__adcSocialConsent = false;

              // Hide only the X element
              const twitterBtn = document.querySelector('.twitter-follow-button');
              if (twitterBtn) twitterBtn.style.display = 'none';

              // Remove rendered iframes. widgets.js replaced the placeholder link with its
              // iframe, so put the empty placeholder back (hidden, and showing nothing), or a
              // later accept would have nothing to render into.
              var rendered = document.querySelectorAll('iframe[src*="platform.twitter.com"]');
              for (var i = 0; i < rendered.length; i++) {
                var ifr = rendered[i];
                if (!ifr || !ifr.parentNode) continue;

                if (/(^|\s)twitter-follow-button(\s|$)/.test(ifr.className) && !document.querySelector('a.twitter-follow-button')) {
                  var placeholder = document.createElement('a');
                  placeholder.href = 'https://twitter.com/adctravel';
                  placeholder.className = 'twitter-follow-button';
                  placeholder.setAttribute('data-show-count', 'true');
                  placeholder.setAttribute('data-show-screen-name', 'false');
                  placeholder.setAttribute('data-dnt', 'true');
                  placeholder.style.display = 'none';
                  ifr.parentNode.insertBefore(placeholder, ifr);
                }

                ifr.parentNode.removeChild(ifr);
              }

              // Remove the injected script
              const twScript = document.getElementById('twitter-wjs');
              if (twScript && twScript.parentNode) twScript.parentNode.removeChild(twScript);

              // The Facebook follow link needs no consent and stays; refill its count in
              // case anything above disturbed it
              showFacebookFollowers();
            } catch (e) {
              // no-op
            }
          }
        }
      ],
      // v9 expects lowercase values
      initialState: 'notify',
      position: 'left',
      theme: 'dark',
      branding: {
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontColor: '#FFF',
        fontSizeTitle: '1.2em',
        fontSizeIntro: '1em',
        fontSizeHeaders: '1em',
        fontSize: '0.8em',
        backgroundColor: '#666666',
        toggleText: '#fff',
        toggleColor: '#999999',
        toggleBackground: '#111125',
        buttonIcon: null,
        buttonIconWidth: '64px',
        buttonIconHeight: '64px',
        removeIcon: false,
        removeAbout: true
      }
    };

    // Compatibility helper for debugging (v8-style name, backed by v9 cookie)
    // Allows: CookieControl.getConsent()
    if (window.CookieControl && typeof window.CookieControl.getConsent !== 'function') {
      window.CookieControl.getConsent = function () {
        try {
          const m = document.cookie.match(/(?:^|;\s*)CookieControl=([^;]*)/);
          const raw = m ? decodeURIComponent(m[1]) : null;
          return raw ? JSON.parse(raw) : null;
        } catch (e) {
          return null;
        }
      };
    }

    // Helper: programmatically "accept" for non-regulated regions
    function autoAcceptForUnregulatedRegions () {
      try {
        const analyticsCategory = baseConfig.optionalCookies.find(function (c) {
          return c.name === 'analytics';
        });

        const advertisingCategory = baseConfig.optionalCookies.find(function (c) {
          return c.name === 'advertising';
        });

        const functionalCategory = baseConfig.optionalCookies.find(function (c) {
          return c.name === 'functional';
        });

        const socialsharingCategory = baseConfig.optionalCookies.find(function (c) {
          return c.name === 'socialsharing';
        });

        if (analyticsCategory && typeof analyticsCategory.onAccept === 'function') {
          analyticsCategory.onAccept();
        } else {
          // eslint-disable-next-line no-console
          console.warn('[CookieControl] Analytics category or onAccept not found for auto-accept.');
        }

        if (advertisingCategory && typeof advertisingCategory.onAccept === 'function') {
          advertisingCategory.onAccept();
        }
        if (functionalCategory && typeof functionalCategory.onAccept === 'function') {
          functionalCategory.onAccept();
        }
        if (socialsharingCategory && typeof socialsharingCategory.onAccept === 'function') {
          socialsharingCategory.onAccept();
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[CookieControl] Error during auto-accept for unregulated regions:', e);
      }
    }

    // 1) Local CCPA test mode
    // - Triggers if URL has ?force_ccpa=1
    // - Loads banner in CCPA mode directly, bypassing geolocation
    if (FORCE_CCPA) {
      const cfgLocal = Object.assign({}, baseConfig, { mode: 'ccpa' });

      // Show fallback for CCPA test mode users who haven't consented yet
      if (!hasFunctionalConsent()) {
        injectGeoFallbackMessage();
      }

      // Default ALL optional categories to OFF in forced CCPA mode (for CA-style testing)
      cfgLocal.optionalCookies = baseConfig.optionalCookies.map(function (c) {
        return Object.assign({}, c, {
          recommendedState: false
        });
      });

      // Make the main "Accept" button accept all categories
      cfgLocal.acceptBehaviour = 'all';

      // Ensure CCPA config exists in forced CCPA mode (Cookie Control v9 expects ccpaConfig)
      if (!cfgLocal.ccpaConfig && baseConfig.ccpaConfig) {
        cfgLocal.ccpaConfig = baseConfig.ccpaConfig;
      }

      // Ensure block flag is set for CCPA mode without existing consent
      if (!hasCookieControlConsent()) {
        window.__ccpaBlockOnAccept = true;
      }

      // Force all categories to OFF state on initial load
      cfgLocal.onLoad = function () {
        // Check if user has actually accepted cookies (not just revoked/default state)
        const hasUserAccepted = function () {
          try {
            const raw = document.cookie.match(/(?:^|;\s*)CookieControl=([^;]*)/);
            if (raw && raw[1]) {
              const consent = JSON.parse(decodeURIComponent(raw[1]));
              // User has accepted if any category is 'accepted'
              return consent.optionalCookies && (
                consent.optionalCookies.analytics === 'accepted' ||
                consent.optionalCookies.advertising === 'accepted' ||
                consent.optionalCookies.functional === 'accepted' ||
                consent.optionalCookies.socialsharing === 'accepted'
              );
            }
          } catch (e) {
            // no-op
          }
          return false;
        };

        // Skip toggle manipulation if user already has saved preferences
        if (hasUserAccepted()) {
          const style = document.getElementById('ccpa-hide-toggles');
          if (style && style.parentNode) style.parentNode.removeChild(style);
          window.__ccpaBlockOnAccept = false;
          // Load geolocation since user has already consented
          loadGeolocationScript();
          // Fall through to apply cookie patch
          // Note: Toggle UI may not match cookie state - this is a known limitation
          // The cookie state is correct; UI will sync on next page load
        } else {
          // Wait for toggles to appear, click them OFF once, then stop
          window.__ccpaTogglesBeingSet = true;
          var toggleCheckInterval = setInterval(function () {
            const allToggles = document.querySelectorAll('.checkbox-toggle-input');
            const checkedToggles = document.querySelectorAll('.checkbox-toggle-input:checked');

            // Wait until all toggles exist and are rendered
            if (allToggles.length > 0) {
              // Click any that are checked to turn them OFF
              for (var k = 0; k < checkedToggles.length; k++) {
                checkedToggles[k].click();
              }

              // Keep block flag true until user explicitly accepts
              window.__ccpaBlockOnAccept = true;

              // Stop checking and clean up after a short delay for animation
              setTimeout(function () {
                const style = document.getElementById('ccpa-hide-toggles');
                if (style && style.parentNode) style.parentNode.removeChild(style);
                window.__ccpaTogglesBeingSet = false;
              }, 100);
              clearInterval(toggleCheckInterval);
            }
          }, 100);

          // Watch for user clicking Accept button
          var checkInterval = setInterval(function () {
            if (hasUserAccepted()) {
              window.__ccpaBlockOnAccept = false;
              // Ensure toggle interval is stopped
              clearInterval(toggleCheckInterval);
              window.__ccpaTogglesBeingSet = false;
              // Remove the loading spinner CSS
              const style = document.getElementById('ccpa-hide-toggles');
              if (style && style.parentNode) style.parentNode.removeChild(style);
              // Only remove fallback and load geolocation if FUNCTIONAL cookies
              // were accepted (not just any category like analytics/advertising)
              var hasFunctionalAcceptedNow = false;
              try {
                var ccRaw = document.cookie.match(/(?:^|;\s*)CookieControl=([^;]*)/);
                if (ccRaw && ccRaw[1]) {
                  var ccObj = JSON.parse(decodeURIComponent(ccRaw[1]));
                  hasFunctionalAcceptedNow = ccObj &&
                    ccObj.optionalCookies &&
                    ccObj.optionalCookies.functional === 'accepted';
                }
              } catch (e) {
                // no-op
              }
              if (hasFunctionalAcceptedNow) {
                window.__geoFallbackRemoved = true;
                removeGeoFallbackMessage();
                loadGeolocationScript();
              }
              clearInterval(checkInterval);
            }
          }, 200);
        }

        // (Cookie patch removed - "Do Not Sell" now revokes all categories as Cookie Control intended)
      };

      CookieControl.load(withGpcOptOut(cfgLocal));
      return;
    }

    // 2) Production geo mode
    //    - GDPR for EU/UK and Brazil (opt-in)
    //    - CCPA for California / withinCCPA (opt-out)
    //    - Auto-accept analytics everywhere else
    CookieControl.geoTest('PRO_MULTISITE', baseConfig.apiKey, function (geo) {
      try {
        /**
         * Expected geo object structure (from Civic API):
         * {
         *   withinEU: boolean | function,
         *   withinCCPA: boolean,
         *   iso: string, // country code
         *   countryCode: string,
         *   country: string,
         *   regionIso: string,
         *   region: string,
         *   subdivisionCode: string,
         *   subdivision: string,
         *   state: string
         * }
         */

        if (typeof geo !== 'object' || geo === null) {
          throw new Error('Invalid geo object');
        }

        // withinEU may be a function or boolean
        const isEU = typeof geo.withinEU === 'function' ? geo.withinEU() : !!geo.withinEU;

        // Country and region/state extraction
        const country = (
          typeof geo.iso === 'string' ? geo.iso : (typeof geo.countryCode === 'string' ? geo.countryCode : (typeof geo.country === 'string' ? geo.country : ''))
        ).toUpperCase();

        // Helper to safely extract and normalize region/state values
        function getRegionCandidates (g) {
          const props = ['regionIso', 'region', 'subdivisionCode', 'subdivision', 'state'];
          return props.map(function (key) {
            const val = g && typeof g[key] === 'string' ? g[key] : '';
            return val.toUpperCase();
          });
        }
        const regionCandidates = getRegionCandidates(geo);

        const isCalifornia =
          regionCandidates.includes('CA') || regionCandidates.includes('CALIFORNIA');

        // Honor Civic's own withinCCPA flag when available
        const civicWithinCCPA = typeof geo.withinCCPA !== 'undefined' ? !!geo.withinCCPA : false;

        // Policy:
        // - GDPR for EU/UK and Brazil
        // - CCPA if Civic says withinCCPA, or if US + region resolves to CA
        const inGDPR = isEU || country === 'BR' || country === 'GB';
        const inCCPA = civicWithinCCPA || (country === 'US' && isCalifornia);

        // Regulated regions (GDPR and/or CCPA): initialize Cookie Control normally
        if (inGDPR || inCCPA) {
          // If both are ever true, prefer GDPR mode
          const cfg = Object.assign({}, baseConfig, { mode: inGDPR ? 'gdpr' : 'ccpa' });

          // Show fallback for users in regulated regions who haven't consented yet
          // (We can't call ipstack until they consent, so give them international options)
          if (!hasFunctionalConsent()) {
            injectGeoFallbackMessage();
          }

          // Remove early-injected CCPA hide style for GDPR-only regions
          if (inGDPR && !inCCPA) {
            const earlyStyleGdpr = document.getElementById('ccpa-hide-toggles');
            if (earlyStyleGdpr && earlyStyleGdpr.parentNode) earlyStyleGdpr.parentNode.removeChild(earlyStyleGdpr);
          }

          // CCPA only tweaks
          if (inCCPA) {
            // Default ALL optional categories to OFF in California. Keep this: it is what keeps the number of
            // California visitors whose data reaches advertising partners low (2026 YTD about 12,600 across ADC and
            // ADV, against 145,319 in 2025 when California defaulted on). The CCPA applies to a business that
            // shares the personal information of 100,000+ California consumers a year (Civ. Code 1798.140(d)(1)(B))
            cfg.optionalCookies = baseConfig.optionalCookies.map(function (c) {
              return Object.assign({}, c, {
                recommendedState: false
              });
            });

            // Make the main "Accept" button accept all categories
            // (If acceptBehaviour stays "recommended" while recommendedState is false,
            // the "Accept" button effectively accepts nothing.)
            cfg.acceptBehaviour = 'all';

            // This is what drives the CCPA button in Cookie Control v9
            cfg.ccpaConfig = {
              description: withGpcText(
                'This may include the website or our third-party tools processing personal information. ' +
                'You may opt out of such activity by using the button below. To find out more about the ' +
                'categories of personal information collected and the purposes for which such information ' +
                'will be used, please refer to our'),
              name: 'Personal Information Policy',
              url: 'https://www.americandiscountvacations.com/privacy#ccpa',
              updated: baseConfig.statement.updated,
              rejectButton: 'Do Not Sell or Share My Personal Information'
            };

            // Ensure block flag is set for CCPA mode without existing consent
            if (!hasCookieControlConsent()) {
              window.__ccpaBlockOnAccept = true;
            }

            const prevOnLoad = cfg.onLoad;

            cfg.onLoad = function () {
              // Check if user has actually accepted cookies (not just revoked/default state)
              const hasUserAccepted = function () {
                try {
                  const raw = document.cookie.match(/(?:^|;\s*)CookieControl=([^;]*)/);
                  if (raw && raw[1]) {
                    const consent = JSON.parse(decodeURIComponent(raw[1]));
                    // User has accepted if any category is 'accepted'
                    return consent.optionalCookies && (
                      consent.optionalCookies.analytics === 'accepted' ||
                      consent.optionalCookies.advertising === 'accepted' ||
                      consent.optionalCookies.functional === 'accepted' ||
                      consent.optionalCookies.socialsharing === 'accepted'
                    );
                  }
                } catch (e) {
                  // no-op
                }
                return false;
              };

              // Skip toggle manipulation if user already has saved preferences
              if (hasUserAccepted()) {
                const style = document.getElementById('ccpa-hide-toggles');
                if (style && style.parentNode) style.parentNode.removeChild(style);
                window.__ccpaBlockOnAccept = false;
                // Load geolocation since user has already consented
                loadGeolocationScript();
                // Fall through to apply cookie patch
                // Note: Toggle UI may not match cookie state - this is a known limitation
                // The cookie state is correct; UI will sync on next page load
              } else {
                // Wait for toggles to appear, click them OFF once, then stop
                window.__ccpaTogglesBeingSet = true;
                var toggleCheckInterval = setInterval(function () {
                  const allToggles = document.querySelectorAll('.checkbox-toggle-input');
                  const checkedToggles = document.querySelectorAll('.checkbox-toggle-input:checked');

                  // Wait until all toggles exist and are rendered
                  if (allToggles.length > 0) {
                    // Click any that are checked to turn them OFF
                    for (var k = 0; k < checkedToggles.length; k++) {
                      checkedToggles[k].click();
                    }

                    // Keep block flag true until user explicitly accepts
                    window.__ccpaBlockOnAccept = true;

                    // Stop checking and clean up after a short delay for animation
                    setTimeout(function () {
                      const style = document.getElementById('ccpa-hide-toggles');
                      if (style && style.parentNode) style.parentNode.removeChild(style);
                      window.__ccpaTogglesBeingSet = false;
                    }, 100);
                    clearInterval(toggleCheckInterval);
                  }
                }, 100);

                // Watch for user clicking Accept button
                var checkInterval = setInterval(function () {
                  if (hasUserAccepted()) {
                    window.__ccpaBlockOnAccept = false;
                    // Ensure toggle interval is stopped
                    clearInterval(toggleCheckInterval);
                    window.__ccpaTogglesBeingSet = false;
                    // Remove the loading spinner CSS
                    const style = document.getElementById('ccpa-hide-toggles');
                    if (style && style.parentNode) style.parentNode.removeChild(style);
                    // Only remove fallback and load geolocation if FUNCTIONAL cookies
                    // were accepted (not just any category like analytics/advertising)
                    var hasFunctionalAcceptedNow = false;
                    try {
                      var ccRaw = document.cookie.match(/(?:^|;\s*)CookieControl=([^;]*)/);
                      if (ccRaw && ccRaw[1]) {
                        var ccObj = JSON.parse(decodeURIComponent(ccRaw[1]));
                        hasFunctionalAcceptedNow = ccObj &&
                          ccObj.optionalCookies &&
                          ccObj.optionalCookies.functional === 'accepted';
                      }
                    } catch (e) {
                      // no-op
                    }
                    if (hasFunctionalAcceptedNow) {
                      window.__geoFallbackRemoved = true;
                      removeGeoFallbackMessage();
                      loadGeolocationScript();
                    }
                    clearInterval(checkInterval);
                  }
                }, 200);
              }

              // Run any existing onLoad first
              try {
                if (typeof prevOnLoad === 'function') prevOnLoad();
              } catch (e) {
                // no-op
              }
            };
          }

          window.CookieControl.load(withGpcOptOut(cfg));
        } else {
          // Remove early-injected CCPA hide style for non-regulated regions
          const earlyStyleNonReg = document.getElementById('ccpa-hide-toggles');
          if (earlyStyleNonReg && earlyStyleNonReg.parentNode) earlyStyleNonReg.parentNode.removeChild(earlyStyleNonReg);

          // Non-regulated regions
          // - Initialize Cookie Control (so consent state + settings UI + logging exist)
          // - Keep it closed (no banner)
          // - Auto-accept your "recommended" categories programmatically

          const cfgNonReg = Object.assign({}, baseConfig, {
            optionalCookies: baseConfig.optionalCookies.map(function (c) {
              // Force defaults to ON for non-regulated regions
              return Object.assign({}, c, { recommendedState: true });
            }),
            // With GPC on, open the banner so the "Opt-Out Request Honored" notice is visible on arrival
            initialState: HAS_GPC ? 'notify' : 'closed',
            notifyOnce: true,
            onLoad: function () {
              // Helper to read a cookie value safely (local copy)
              function getCookieValue (name) {
                try {
                  const m = document.cookie.match(
                    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
                  );
                  return m ? decodeURIComponent(m[1]) : null;
                } catch (e) {
                  return null;
                }
              }

              // Keep widget hidden/minimized in non-regulated regions,
              // but if GPC is present, leave it visible so the user can manage choices
              if (!HAS_GPC) {
                try {
                  if (window.CookieControl && typeof window.CookieControl.hide === 'function') {
                    window.CookieControl.hide();
                  }
                } catch (e) {
                  // no-op
                }
              }

              // Only auto-accept if there are NO saved optional cookie preferences yet
              let hasSavedOptionalPrefs = false;
              try {
                const ccRaw = getCookieValue('CookieControl');
                if (ccRaw) {
                  const ccObj = JSON.parse(ccRaw);
                  hasSavedOptionalPrefs =
                    !!(ccObj &&
                       ccObj.optionalCookies &&
                       Object.keys(ccObj.optionalCookies).length > 0);
                }
              } catch (e) {
                // no-op
              }

              if (!hasSavedOptionalPrefs) {
                // Respect GPC, do not auto-accept when the user signals "do not track"
                if (HAS_GPC) return;

                try {
                  if (window.CookieControl && typeof window.CookieControl.acceptAll === 'function') {
                    window.CookieControl.acceptAll();
                  } else {
                    autoAcceptForUnregulatedRegions();
                  }
                } catch (e) {
                  // no-op
                }
              }
            }
          });

          CookieControl.load(withGpcOptOut(cfgNonReg));
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[CookieControl] geoTest error - suppressing banner but not analytics:', e);
        // Fallback is "no banner, no analytics" (we do not auto-accept here on failure)
      }
    });
  };
  (document.body || document.head || document.documentElement).appendChild(cookieControlScript);
})();
